import { Box, Heading, Text, VStack } from '@chakra-ui/react'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'

type ContentIntroProps = {
  title: any
  description?: string
}

const ContentIntro = (props: ContentIntroProps) => {
  const { getBreakpointValue } = useBreakpointContext()
  return (
    <VStack align={'center'} gap={4} paddingX={4} paddingY={4} width={'full'}>
      <Heading size={getBreakpointValue(['2xl', '3xl', '4xl'])} textAlign={'center'}>
        {props.title}
      </Heading>
      <Box maxWidth={'container.md'}>
        <Text color={'colorPalette.fg'} fontSize={'2xl'} textAlign={'center'}>
          {props.description}
        </Text>
      </Box>
    </VStack>
  )
}

export default ContentIntro
